// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueList_venue-list__rtJhQ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.VenueList_venue-list__cards__q2Uvp {
  padding: 16px 0px;
  flex-direction: column;
  align-self: stretch;
}
.VenueList_venue-list__rtJhQ .VenueList_results__uJ\\+OU {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
}
.VenueList_venue-list__rtJhQ .VenueList_results__header__iQM7A {
  display: flex;
  padding: 0px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}
.VenueList_venue-list__rtJhQ .VenueList_results__body__bG27r {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}
.VenueList_venue-list__rtJhQ .VenueList_results--controller__pihNc {
  align-self: flex-end;
}
.VenueList_venue-list__rtJhQ .VenueList_results--title__QEFAG {
  text-align: center;
  color: var(--accent-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.VenueList_venue-list__rtJhQ .VenueList_results--description__YzYJc {
  color: var(--grey-text);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.VenueList_venue-list__rtJhQ .VenueList_right-section__DlsSi {
  max-width: 300px;
  width: 100%;
}
.VenueList_venue-list__rtJhQ .VenueList_card__m02CE {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.VenueList_venue-list__rtJhQ .VenueList_card__m02CE:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(30, 58, 95, 0.1);
}
@media only screen and (max-width: 900px) {
  .VenueList_venue-list__rtJhQ {
    flex-direction: column;
    gap: 20px;
  }
  .VenueList_venue-list__rtJhQ .VenueList_search-filter__lOFbZ {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 20px;
    width: 100%;
  }
  .VenueList_venue-list__rtJhQ .VenueList_search-filter__lOFbZ .VenueList_search-landscape__BexBe {
    display: none;
  }
  .VenueList_venue-list__rtJhQ .VenueList_search-filter__lOFbZ .VenueList_search-mobile__TZ4Cw {
    width: 100%;
    display: block;
  }
  .VenueList_venue-list__rtJhQ .VenueList_filters-results__SPGLp .VenueList_results__uJ\\+OU {
    width: 100%;
  }
  .VenueList_venue-list__rtJhQ .VenueList_filters-results__SPGLp .VenueList_results--title__QEFAG {
    font-size: 20px;
  }
  .VenueList_venue-list__rtJhQ .VenueList_right-section__DlsSi {
    max-width: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueList/VenueList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACE;EACE,iBAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AAEE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AADN;AAII;EACE,oBAAA;AAFN;AAKI;EACE,kBAAA;EACA,0BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAMI;EACE,uBAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;AAQE;EACE,gBAAA;EACA,WAAA;AANJ;AASE;EACE,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,iDAAA;AAPJ;AASI;EACE,2BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mCAAA;AAPN;AAWE;EApFF;IAqFI,sBAAA;IACA,SAAA;EARF;EAUE;IACE,aAAA;IACA,8BAAA;IACA,QAAA;IACA,mBAAA;IACA,WAAA;EARJ;EAUI;IACE,aAAA;EARN;EAWI;IACE,WAAA;IACA,cAAA;EATN;EAcI;IACE,WAAA;EAZN;EAcM;IACE,eAAA;EAZR;EAiBE;IACE,kBAAA;EAfJ;AACF","sourcesContent":[".venue-list {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n\n  &__cards {\n    padding: 16px 0px;\n    flex-direction: column;\n    align-self: stretch;\n  }\n\n  .results {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 40px;\n    align-self: stretch;\n\n    &__header {\n      display: flex;\n      padding: 0px 40px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 12px;\n      align-self: stretch;\n    }\n\n    &__body {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      align-self: stretch;\n    }\n\n    &--controller {\n      align-self: flex-end;\n    }\n\n    &--title {\n      text-align: center;\n      color: var(--accent-color);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    &--description {\n      color: var(--grey-text);\n      text-align: center;\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  .right-section {\n    max-width: 300px;\n    width: 100%;\n  }\n\n  .card {\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 16px;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n    &:hover {\n      transform: translateY(-4px);\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n      background: rgba(255, 255, 255, 0.9);\n      border-color: rgba(30, 58, 95, 0.1);\n    }\n  }\n\n  @media only screen and (max-width: 900px) {\n    flex-direction: column;\n    gap: 20px;\n\n    .search-filter {\n      display: flex;\n      justify-content: space-between;\n      gap: 8px;\n      margin-bottom: 20px;\n      width: 100%;\n\n      .search-landscape {\n        display: none;\n      }\n\n      .search-mobile {\n        width: 100%;\n        display: block;\n      }\n    }\n\n    .filters-results {\n      .results {\n        width: 100%;\n\n        &--title {\n          font-size: 20px;\n        }\n      }\n    }\n\n    .right-section {\n      max-width: initial;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venue-list": `VenueList_venue-list__rtJhQ`,
	"venue-list__cards": `VenueList_venue-list__cards__q2Uvp`,
	"results": `VenueList_results__uJ+OU`,
	"results__header": `VenueList_results__header__iQM7A`,
	"results__body": `VenueList_results__body__bG27r`,
	"results--controller": `VenueList_results--controller__pihNc`,
	"results--title": `VenueList_results--title__QEFAG`,
	"results--description": `VenueList_results--description__YzYJc`,
	"right-section": `VenueList_right-section__DlsSi`,
	"card": `VenueList_card__m02CE`,
	"search-filter": `VenueList_search-filter__lOFbZ`,
	"search-landscape": `VenueList_search-landscape__BexBe`,
	"search-mobile": `VenueList_search-mobile__TZ4Cw`,
	"filters-results": `VenueList_filters-results__SPGLp`
};
export default ___CSS_LOADER_EXPORT___;
